import React, { forwardRef } from 'react'
import StepAddPhotos from '../createLocation/StepAddPhotos';

interface Props {
    onClose: () => void;
    onDone: () => void;
    setFolderEntries: any;
    folderEntries: any;
    setView: any;
    view: any;
    fetchFolders: any
}

const UploadPhotoAndFolder = forwardRef(({ onClose, onDone, setFolderEntries, folderEntries, setView, view, fetchFolders }: Props, ref) => {
    return (
        <>
            {/* Backdrop */}
            <div className="cl-backdrop" />

            {/* Drawer panel */}
            <div className="cl-drawer">

                {/* Header */}
                <div className="cl-drawer__header">
                    <button className="cl-drawer__close" onClick={onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="cl-drawer__title">Create Location</h2>
                </div>

                {/* Step content */}
                <div className="cl-drawer__body">
                    <StepAddPhotos
                        setFolderEntries={setFolderEntries}
                        folderEntries={folderEntries}
                        setView={setView}
                        onRefresh={fetchFolders}
                        view={view}
                        ref={ref}
                    />
                </div>

                {/* Footer: dots + action button */}
                <div className="cl-drawer__footer">
                    <button className="cl-btn-next" onClick={onDone}>
                        {view == 'new-folder' ? 'Create Folder' : 'Save & Create'}
                    </button>
                </div>
            </div>
        </>
    )
});

export default UploadPhotoAndFolder